/**
 * @Author: Zewei
 * @Date:   2018-01-22T19:00:37+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-02-05T20:18:09+08:00
 */

import { SystemSettingConstants } from '../constants/system-setting-constants.js';
import _util from '../utils/index.js';
import roleManagementService from '../services/SystemSetting/role-management-service.js';
import userManagementService from '../services/SystemSetting/user-management-service.js';
import SystemLoggerService from '../services/SystemSetting/system-logger-service.js';
import { message } from "antd";

// 角色管理 action creators
export function fetchRoleList (params) {
    return dispatch => {
        roleManagementService.fetchRoleList(params, (res) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSUCCESS,
                payload: {
                    roleList: res.data,
                    actionStatus: false,
                }
            })
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHFAILURE,
                payload: {
                    err,
                    // status: false,
                    actionStatus: false,
                 }
            })
        })
    }
}

export function addRoleInit () {
    return dispatch => {
        roleManagementService.fetchRoleInit((res) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSUCCESS,
                payload: {
                    initRole: res.data,
                    // status: true
                }
            })
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHFAILURE,
                payload: {
                    err,
                    // status: false
                }
            })
        })
    }
}

export function createNewRole (payload) {
    return dispatch => {
        roleManagementService.createNewRole(payload, (res) => {
            // console.log(res)
            if (res.data.Success) {
                dispatch({
                    type: SystemSettingConstants.ActionTypes.CREATEROLESUCCESS,
                    payload: {
                        actionStatus: true
                    }
                })
                _util.successTips('创建成功');
            } else {
                throw new Error('Create Role Failed');
            }
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.CREATEROLEFAILURE,
                payload: {
                    actionStatus: false
                }
            })
            _util.errorTips('创建失败');
        })
    }
}

export function deleteRoles (params) {
    return dispatch => {
        roleManagementService.deleteRoles(params, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: SystemSettingConstants.ActionTypes.DELETEROLESSUCCESS,
                    payload: {
                        actionStatus: true
                    }
                })
                _util.successTips('删除成功');
            } else {
                throw new Error('Delete Role Failed');
            }
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.DELETEROLESFAILURE,
                payload: {
                    err,
                    actionStatus: false
                }
            })
            _util.errorTips('删除失败');
        })
    }
}

export function fetchRoleDetail (params) {
    return dispatch => {
        roleManagementService.fetchRoleDetail(params, (res) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSUCCESS,
                payload: {
                    roleDetail: res.data.Role,
                    asyncModalVisible: true
                }
            })
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHFAILURE,
                payload: {
                    asyncModalVisible: false
                }
            })
        })
    }
}

export function hiddenAsyncModal () {
    return (dispatch) => {
        dispatch({
            type: SystemSettingConstants.ActionTypes.HIDDENMODAL,
            payload: {
                roleDetail: null,
                asyncModalVisible: false,
            }
        })
    }
}

export function updateRole (payload) {
    return dispatch => {
        roleManagementService.updateRole(payload, (res) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.CREATEROLESUCCESS,
                payload: {
                    asyncModalVisible: false,
                    actionStatus: true
                }
            })
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.CREATEROLEFAILURE,
                payload: {
                    asyncModalVisible: false,
                    actionStatus: false
                }
            })
        })
    }
}

// 用户管理 action creators
export function fetchUserList (params) {
    return dispatch => {
        userManagementService.fetchUserList(params, (res) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSUCCESS,
                payload: {
                    userList: res.data,
                    actionStatus: false
                }
            })
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHFAILURE,
                payload: {
                    actionStatus: false
                }
            })
        })
    }
}
export function fetchUserInit () {
    return dispatch => {
        userManagementService.fetchUserInit((res) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSUCCESS,
                payload: {
                    initUser: res.data,
                    actionStatus: false
                }
            })
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHFAILURE,
                payload: {
                    actionStatus: false
                }
            })
        })
    }
}
export function createNewUser (data, callback) {
    return dispatch => {
        userManagementService.createNewUser(data, (res) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.CREATEROLESUCCESS,
                payload: {
                    actionStatus: true
                }
            })
            if (!res.data.Success) {
                _util.errorTips('添加用户失败,'+ res.data.Errors[0])
            }else{
                message.success("创建用户成功");
                callback(true);
            }
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.CREATEROLEFAILURE,
                payload: {
                    actionStatus: false
                }
            })
            _util.errorTips('添加用户失败')
        })
    }
}
export function hiddenEditUserModal () {
    return (dispatch) => {
        dispatch({
            type: SystemSettingConstants.ActionTypes.HIDDENMODAL,
            payload: {
                userDetail: null,
                userEditModalVisible: false,
            }
        })
    }
}

export function deleteUsers(datas) {
    return dispatch => {
        userManagementService.deleteUsers(datas, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: SystemSettingConstants.ActionTypes.DELETEUSERSSUCCESS,
                    payload: {
                        // ids: datas,
                        actionStatus: true,
                    }
                })
                _util.successTips('删除用户成功')
            }
            if (!res.data.Success) {
                _util.errorTips('删除用户失败,'+ res.data.Errors[0])
            }
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.DELETEUSERSFAILURE,
                payload: {
                    actionStatus: false
                }
            })
            _util.errorTips('删除用户失败')
        })
    }
}
export function handleAuthorize(datas) {
    return dispatch => {
        userManagementService.handleAuthorize(datas, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: SystemSettingConstants.ActionTypes.HANDLEAUTHORIZESUCCESS,
                    payload: {
                        // ids: datas,
                        actionStatus: true,
                    }
                })
                _util.successTips('授权成功')
            }
            if (!res.data.Success) {
                _util.errorTips('授权失败,'+ res.data.Errors[0])
            }
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.HANDLEAUTHORIZESUCCESS,
                payload: {
                    actionStatus: false
                }
            })
            _util.errorTips('授权失败')
        })
    }
}
export function inactiveUsers(datas) {
    return dispatch => {
        userManagementService.inactiveUsers(datas, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: SystemSettingConstants.ActionTypes.DELETEUSERSSUCCESS,
                    payload: {
                        actionStatus: true,
                    }
                })
                _util.successTips('冻结用户成功')
            } else {
                throw new Error('冻结用户失败')
            }
            if (!res.data.Success) {
                _util.errorTips('冻结用户失败,'+ res.data.Errors[0])
            }
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.DELETEUSERSFAILURE,
                payload: {
                    actionStatus: false
                }
            })
            _util.errorTips('冻结用户失败')
        })
    }
}

export function fetchUserDetail(params) {
    return dispatch => {
        userManagementService.fetchUserDetail(params, (res) => {
            if (res.data) {
                dispatch({
                    type: SystemSettingConstants.ActionTypes.FETCHSUCCESS,
                    payload: {
                        userDetail: res.data,
                        actionStatus: true,
                        userEditModalVisible: true,
                    }
                })
                // _util.successTips('用户成功')
            } else {
                throw new Error('获取用户失败')
            }
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHFAILURE,
                payload: {
                    actionStatus: false,
                    userEditModalVisible: false,
                }
            })
        })
    }
}

export function updateUserDetail(data, callback) {
    return dispatch => {
        userManagementService.updateUserDetail(data, (res) => {
            // console.log(res)
            if (res.data.Success) {
                dispatch({
                    type: SystemSettingConstants.ActionTypes.UPDATEUSERSUCCESS,
                    payload: {
                        // userDetail: res.data,
                        actionStatus: true,
                        userEditModalVisible: false,
                    }
                })
                _util.successTips('用户更新成功')
                callback(true)
            }
            if (!res.data.Success) {
                _util.errorTips('更新用户失败,'+ res.data.Errors[0])
            }
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.UPDATEUSERFAILURE,
                payload: {
                    actionStatus: false,
                    userEditModalVisible: false,
                }
            })
            _util.errorTips('用户更新失败')
        })
    }
}

export function resetUsersPassword(data) {
    return dispatch => {
        userManagementService.resetUsersPassword(data, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: SystemSettingConstants.ActionTypes.UPDATEUSERSUCCESS,
                    payload: {
                        actionStatus: true,
                    }
                })
                _util.successTips('密码重置成功')
            } else {
                throw new Error('密码重置失败')
            }
        }, (err) => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.UPDATEUSERFAILURE,
                payload: {
                    actionStatus: false,
                }
            })
            _util.errorTips('密码重置失败')
        })
    }
}


// logger action creators
export function initSystemLogger() {
    return dispatch => {
        dispatch({
            type: SystemSettingConstants.ActionTypes.INITSYSTEMLOGGER,
            payload: {
                status: 'loading'
            }
        })
    }
}

export function fetchSystemLogger(params = '') {
    return dispatch => {
        SystemLoggerService.fetchSystemLogger(params, res => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSYSTEMLOGGERSUCCESS,
                payload: {
                    res: res,
                    status: 'loaded'
                }
            })
        }, err => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSYSTEMLOGGERFAILURE,
                payload: {
                    res: err,
                    status: 'error'
                }
            })
        })
    }
}

export function initSystemLoggerSetting() {
    return dispatch => {
        dispatch({
            type: SystemSettingConstants.ActionTypes.INITSYSTEMLOGGERSETTING,
            payload: {
                settingStatus: 'loading'
            }
        })
    }
}

export function fetchSystemLoggerSetting(params) {
    return dispatch => {
        SystemLoggerService.fetchSystemLoggerSetting(params, res => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSYSTEMLOGGERSETTINGSUCCESS,
                payload: {
                    settingRes: res,
                    settingStatus: 'loaded'
                }
            });
        }, err => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSYSTEMLOGGERSETTINGFAILURE,
                payload: {
                    settingRes: err,
                    settingStatus: 'error'
                }
            });
        });
    }
}

export function addSystemLoggerSetting(datas, callback) {
    return dispatch => {
        SystemLoggerService.addSystemLoggerSetting(datas, res => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.ADDSYSTEMLOGGERSETTINGSUCCESS,
                payload: {
                    settingSaveRes: res,
                    settingSaveStatus: true
                }
            });
            if ('function' === typeof callback){
                callback(true);
            }
        }, err => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.ADDSYSTEMLOGGERSETTINGFAILURE,
                payload: {
                    settingSaveRes: err,
                    settingSaveStatus: false
                }
            });
            if ('function' === typeof callback){
                callback(false);
            }
        });
    }
}

export function saveSystemLoggerSetting(datas, callback) {
    return dispatch => {
        SystemLoggerService.saveSystemLoggerSetting(datas, res => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.SAVESYSTEMLOGGERSETTINGSUCCESS,
                payload: {
                    settingSaveRes: res,
                    settingSaveStatus: true
                }
            });
            if ('function' === typeof callback){
                callback(true);
            }
        }, err => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.SAVESYSTEMLOGGERSETTINGFAILURE,
                payload: {
                    settingSaveRes: err,
                    settingSaveStatus: false
                }
            });
            if ('function' === typeof callback){
                callback(false);
            }
        });
    }
}


export function fetchSystemModule() {
    return dispatch => {
        SystemLoggerService.fetchSystemModule(res => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSYSTEMMODULESUCCESS,
                payload: {
                    moduleRes: res,
                    moduleStatus: true
                }
            });
        }, err => {
            dispatch({
                type: SystemSettingConstants.ActionTypes.FETCHSYSTEMMODULEFAILURE,
                payload: {
                    moduleRes: err,
                    moduleStatus: false
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/actions/system-setting-actions.js